import { FALLBACK_LOCALE } from '_constants'
import { buildTimeCountryConfig } from 'config'
import { EnumUserLocale } from '../types/locale'

export const getCountryConfigByLocale = (userLocale: EnumUserLocale) => {
  return (
    buildTimeCountryConfig[userLocale] ||
    buildTimeCountryConfig[FALLBACK_LOCALE]
  )
}
